import React, { FC, MutableRefObject, ReactElement, useContext, useEffect, useState } from 'react'
import useIsMountedRef from 'use-is-mounted-ref'
import CLanguageHandler from '../../../../../NonReact/Languages/LanguageHandler'
import { LanguageContext, ReactState } from '../../../../../React/Common/Contexts'
import { ChangeLangLanguage } from '../../../../../../i18n'
import { LocaleEntries } from '../../../Molecules/LoginForm/Types/Types'
import { EMPTY_STRING } from '../../../../../NonReact/constants/Common'
import { LOCALE_EN_GB } from '../../../../../React/Common/Constants/Locale'
import { getLocales } from '../../../../../React/Common/API/ItemsGetters'
import { isVarNotEmpty } from '../../../../../NonReact/utils/GlobalFunctions'
import { displayError } from '../../../../../React/Common/Utils/Messages'
import { OutlinedSelect } from '../../../Atoms/Inputs/OutlinedSelect'
import { LocaleEntry } from '../../../../../React/Common/Types/Types'
import { SelectOption } from '../../../../../React/Common/Components/Selects/Types'
import { RouterCheckbox } from '../../../Atoms/Inputs/RouterCheckbox'
import { FooterActions } from '../Actions/FooterActions'
import { getSessionLanguage } from '../../../../../React/Common/API/LanguageAPI'
import { hasCookie } from '../../../../../NonReact/utils/StorageUtils'
import { LOCALE_COOKIE } from '../../../Molecules/LoginForm/Constants/Constants'

export const ChangeLanguage: FC = (): ReactElement => {
    const language: CLanguageHandler = useContext(LanguageContext) as CLanguageHandler
    language.loadBundle(ChangeLangLanguage.NAME)

    const isMounted: MutableRefObject<boolean> = useIsMountedRef()

    const [selectedLanguage, setSelectedLanguage]: ReactState<string> = useState<string>(LOCALE_EN_GB)
    const [rememberLanguage, setRememberLanguage]: ReactState<boolean> = useState<boolean>(hasCookie(LOCALE_COOKIE))

    const [availableLanguages, setAvailableLanguages]: ReactState<LocaleEntries> = useState<LocaleEntries>([
        {
            description: EMPTY_STRING,
            locale: LOCALE_EN_GB
        }
    ])

    useEffect((): void => {
        getSessionLanguage().then((sessionLanguage: Nullable<string>): void => {
            if (isVarNotEmpty(sessionLanguage) && isMounted.current) {
                setSelectedLanguage(sessionLanguage)
            }
        })

        getLocales()
            .then((locales: Nullable<LocaleEntries>): void => {
                if (isVarNotEmpty(locales) && isMounted.current) {
                    setAvailableLanguages(locales)
                }
            })
            .catch(displayError)
    }, [])

    return (
        <div className='change-language-content'>
            <h1 className='cl-title'>{language.get(ChangeLangLanguage.ChangeLang_Title)}</h1>
            <h2 className='cl-subtitle'>{language.get(ChangeLangLanguage.ChangeLang_Subtitle)}</h2>

            <OutlinedSelect
                containerClassName='cl-select'
                label={language.get(ChangeLangLanguage.ChangeLang_Field_Label)}
                options={availableLanguages.map(
                    ({ locale, description }: LocaleEntry): SelectOption<string> => ({
                        label: description,
                        value: locale
                    })
                )}
                value={selectedLanguage}
                handleChange={setSelectedLanguage}
            />

            <RouterCheckbox
                id='cl-remember-language'
                className='cl-remember-language'
                labelRight={language.get(ChangeLangLanguage.ChangeLang_Remember_Label)}
                isChecked={rememberLanguage}
                onChange={setRememberLanguage}
            />

            <FooterActions selectedLanguage={selectedLanguage} rememberLanguage={rememberLanguage} />
        </div>
    )
}
